import React, { FC, ReactNode, useEffect, useState } from 'react';
import classNames from 'classnames';
import { Portal } from 'ncoded-component-library';
import { INITIAL_POSITION } from 'data/global';

import './ChartTooltip.styles.scss';

const TOP_PADDING = 20;

type ChartTooltipProps = {
  className?: string;
  children?: ReactNode;
  url?: string;
  alt?: string;
  isOpen?: boolean;
};

const ChartTooltip: FC<ChartTooltipProps> = ({
  className,
  children,
  url,
  alt,
  isOpen,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [mousePosition, setMousePosition] = useState(INITIAL_POSITION);

  const hasImage = !!url;

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) =>
      setMousePosition({
        left: event.clientX,
        top: event.clientY - TOP_PADDING,
      });

    const handleScroll = () => setMousePosition(INITIAL_POSITION);

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll, true);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <Portal isOpen={isOpen}>
      <div
        className={classNames('chart-tooltip', className, {
          'chart-tooltip--image': hasImage,
          'chart-tooltip--loaded': isLoaded,
        })}
        style={mousePosition}
      >
        {hasImage && (
          <img src={url} alt={alt || ''} onLoad={() => setIsLoaded(true)} />
        )}
        {children}
      </div>
    </Portal>
  );
};

export default ChartTooltip;
